import prop1 from '../assets/pic1.png'; 
import prop2 from '../assets/pic2.png'
import prop3 from '../assets/pic3.png'
import prop4 from '../assets/pic5.png'
const ProjectCard = [

    {
        imgsrc:prop4,
        title:"Blog Application .",
        text:"This is MERN Stack project ,Inside this I have used Nodejs,Reactjs,Mongodb .",
        view:"https://jolly-long-johns-fawn.cyclic.app/",
        git:'https://github.com/vicky040/Blog-Application'
       
    },
    {
        imgsrc:prop2, 
        title:"Feedback UI .",
        text:"This is frontend project , Inside this I have used ReactJs .",
        view:"https://uifeedback.netlify.app", 
        git:'https://github.com/vicky040/Feedback-UI'
    }, 
    {
        imgsrc:prop3,
        title:"Employee Management .",
        text:"This is frontend project , Inside this I have used ReactJs .",
        view:"https://employeemanageme.netlify.app/",
        git:"https://github.com/vicky040/project-"
    }, 
    {
        imgsrc:prop1,
        title:"Quiz Website .",
        text:"This is frontend project , Inside this I have used ReactJs .",
        view:"https://quizapllication.netlify.app",
        git:'https://github.com/vicky040/quizproject'
       
    }
    
   
]

export default ProjectCard ; 